import RangeColumnChart from "./RangeColumnChart";
export default RangeColumnChart;